
export default {
  init() {
    // JavaScript to be fired on the branch page, after the init JS

       
    $('.send-reason-form').on('submit', function(e) {
      e.preventDefault();
      
      var $form = $(this);
  
      $.post(
          $form.attr('action'),
          $form.serialize(), 
          function(response) {
              if(response == 'error'){
                  $('.modal-body .alert-danger').removeClass('d-none');
              }else{
                  $('.modal-body .alert-success').removeClass('d-none');
              }
          }
      );
  
      $( document ).ajaxStart(function(){
          $('.modal-body .loading').removeClass('d-none');
      });
      $( document ).ajaxStop(function(){
          $('.modal-body .loading').addClass('d-none');
      });
    });
    
    $('.send-issue').hide();
    
    $('.toggleIssueForm').on('click', function(el) {
       el.preventDefault();
       $('.send-issue').slideToggle();
       $('#st_issue').focus();
    });
    
    $('.send-issue').on('submit', function(e) {
      e.preventDefault();
      
      var $form = $(this);
      $(this).addClass('idle');
      $.post(
          $form.attr('action'),
          $form.serialize(),

          function(response) {
              if(response == 'error'){
                  $('.send-issue .alert-danger').slideDown();
              }else{
                  $('.send-issue').removeClass('idle');
                  $('.send-issue .alert-success').slideDown();
                  $('#st_issue').val('');
                setTimeout(function() {
                $('.send-issue').slideUp();
                $('.send-issue .alert-success').slideUp();
                $('.send-issue .alert-danger').slideUp();
                }, 4000)
                  
              }
          }
      );
  
    });

	$('[data-toggle="tooltip"]').tooltip();
  },

  

  finalize() {
      // JavaScript to be fired on the branch page
      
	$('.register-link').on('click', function() {
		if (window.matchMedia("(max-width: 700px)").matches) {
			$('html, body').animate({ scrollTop: $('#registerList').offset().top }, 500);
		} else {
			$('html, body').animate({ scrollTop: $('#registerList').offset().top-76 }, 500);
		}
		
		
	});
      
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/district.js